import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../../AppContext";
import { compactSelect, compactSelectError } from "../../../design/selectStyle";
import { useOpenBanking } from "../UseOpenBanking";

const PayrollBankAccounts = ({ payroll, handleChange, disabled, validationErrors }) => {
  const { t } = useTranslation("translations");
  const { user: [user], selectedCompany: [selectedCompany], company: [fullCompany] } = useAppContext();
  const { bankAccounts } = useOpenBanking();

  const filteredBankAccounts = useMemo(() => {
    return (bankAccounts || []).filter(account => account.isOpenBanking);
  }, [bankAccounts]);

  const defaultsSetRef = useRef(false);

  useEffect(() => {
    if (defaultsSetRef.current) return;
    const isCreateFlow = !payroll?.id;
    const noAccountSelected = !payroll?.companyBankAccount;
    if (!isCreateFlow || !noAccountSelected) return;
    if (!filteredBankAccounts?.length) return;

    const defaultAccount = filteredBankAccounts.find(
      acc => acc.financialInstitution?.name === "Banka Kombëtare Tregtare"
    );

    if (defaultAccount) {
      defaultsSetRef.current = true; 
      handleChange(null, "companyBankAccount", defaultAccount);
    }
  }, [filteredBankAccounts, payroll?.id, payroll?.companyBankAccount, handleChange]);


  const selectValue = payroll?.companyBankAccount
    ? filteredBankAccounts.find(a => a.id === payroll.companyBankAccount.id) ?? null
    : null;

  return (
    <div className="row mx-1 mx-md-auto">
      <div className="col-12 pt-0 ">
        <div className="row">
          <div className="d-flex justify-content-between header border-bottom w-full pl-1" style={{ width: "100%" }}>
            <div>
              <label>{t("payRoll.companyBankAccount")}</label>
            </div>
          </div>

          <div className="col-12 pt-0 pt-2">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <label className="field-label" htmlFor="companyBankAccounts">
                  {t("payRoll.searchByName")}
                </label>
              </div>
            </div>

            <Select
              options={filteredBankAccounts}
              getOptionLabel={(option) => `${option?.iban} - ${option?.currency} - ${option.financialInstitution?.name}`}
              getOptionValue={(option) => option?.id}
              styles={validationErrors?.companyBankAccount ? compactSelectError : compactSelect}
              value={selectValue}
              onChange={(bankAccount) => {
                handleChange(null, "companyBankAccount", bankAccount);
              }}
              isDisabled={disabled}
              isClearable={true}
            />

            <div>
              <div className="field-label">{t("payRoll.iban")}</div>
              <div className="smaller-text">{payroll?.companyBankAccount?.iban}</div>
            </div>

            <div>
              <div className="field-label">{t("payRoll.bankName")}</div>
              <div className="smaller-text">{payroll?.companyBankAccount?.financialInstitution?.name}</div>
            </div>

            <div>
              <div className="field-label">{t("payRoll.bankAccountNumber")}</div>
              <div className="smaller-text">{payroll?.companyBankAccount?.accountNo}</div>
            </div>

            <div>
              <div className="field-label">{t("payRoll.currency")}</div>
              <div className="smaller-text">{payroll?.companyBankAccount?.currency}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollBankAccounts;